/* eslint-disable angular/window-service */
/* eslint-disable angular/document-service */
/* eslint-disable unicorn/consistent-function-scoping */
import {getLocationColorAndFlag} from '../../shared/location-flag-and-color'
import {formatQualificationDateToPqe} from '../../shared/services/format-pqe'
;(function module() {
  'use strict'

  angular.module('app.ui.form.ctrls').controller('CandidateListingController', [
    '$scope',
    '$log',
    '$location',
    'usSpinnerService',
    'logger',
    '$window',
    '$uibModal',
    '$sce',
    'SharedApi',
    'CandidateListingApi',
    'EmployersApi',
    'CandidateProfileApi',
    'ApplicationsApi',
    'NotesApi',
    'userService',
    'socket',
    '$rootScope',
    function controller(
      $scope,
      $log,
      $location,
      usSpinnerService,
      logger,
      $window,
      $uibModal,
      $sce,
      SharedApi,
      CandidateListingApi,
      EmployersApi,
      CandidateProfileApi,
      ApplicationsApi,
      NotesApi,
      userService,
      socket,
      $rootScope
    ) {
      let vm = this
      let defaultFilter

      vm.candidateUpdated = async candidateId => {
        const {
          data: updatedCandidate,
        } = await CandidateListingApi.getCandidateListing({id: candidateId})

        const formatCandidate = setCandidateListingData(updatedCandidate)

        const updateCandidateIndex =
          vm.candidateListing &&
          vm.candidateListing.findIndex(({id}) => id === candidateId)

        vm.candidateListing[updateCandidateIndex] = formatCandidate[0]

        vm.gridOptions.api.updateRowData({
          update: formatCandidate,
        })

        updateGridGroupPipeline()
        $scope.$apply()
      }

      socket.on('CANDIDATE_PROFILE_CREATE', async candidateId => {
        const {
          data: newCandidate,
        } = await CandidateListingApi.getCandidateListing({id: candidateId})

        const formatCandidate = setCandidateListingData(newCandidate)

        vm.candidateListing = [...vm.candidateListing, ...formatCandidate]
        vm.gridOptions.api.updateRowData({
          addIndex: vm.candidateListing.length,
          add: formatCandidate,
        })
        updateGridGroupPipeline()
      })
      socket.on('CANDIDATE_PROFILE_UPDATE', async candidateId => {
        const {
          data: updatedCandidate,
        } = await CandidateListingApi.getCandidateListing({id: candidateId})

        if (
          !vm.schoolList.some(
            ({id}) => id === updatedCandidate[0].candidateProfile.school
          )
        ) {
          const {data: schoolList} = await SharedApi.getAllSchools()
          vm.schoolList = schoolList
        }

        const formatCandidate = setCandidateListingData(updatedCandidate)

        const updateCandidateIndex =
          vm.candidateListing &&
          vm.candidateListing.findIndex(({id}) => id === candidateId)

        vm.candidateListing[updateCandidateIndex] = formatCandidate[0]

        vm.gridOptions.api.updateRowData({
          update: formatCandidate,
        })

        updateGridGroupPipeline()
        $scope.$apply()
      })

      socket.on('CANDIDATE_ASSIGNED_AGENT_UPDATE', async candidateId => {
        await vm.candidateUpdated(candidateId)
      })

      socket.on('USER_DELETED', async candidateId => {
        const deleteCandidate = vm.candidateListing.filter(
          ({id}) => id === candidateId
        )
        vm.candidateListing = vm.candidateListing.filter(
          ({id}) => id !== candidateId
        )
        vm.gridOptions.api.updateRowData({remove: deleteCandidate})

        updateGridGroupPipeline()
        $rootScope.$broadcast('candidate-deleted', {
          candidateDeleted: candidateId,
        })
      })

      socket.on('CANDIDATE_APPROVAL_STATUS_UPDATE', async candidateId => {
        await vm.candidateUpdated(candidateId)
      })

      socket.on('USER_UPDATED', async candidateId => {
        await vm.candidateUpdated(candidateId)
      })
      socket.on('SALARY_CREATED', async candidateId => {
        await vm.candidateUpdated(candidateId)
      })
      socket.on('SALARY_UPDATED', async candidateId => {
        await vm.candidateUpdated(candidateId)
      })

      socket.on('CANDIDATE_EMPLOYER_UPDATED', async candidateId => {
        await vm.candidateUpdated(candidateId)
      })
      socket.on('CANDIDATE_POSITION_UPDATED', async candidateId => {
        await vm.candidateUpdated(candidateId)
      })

      socket.on('EMPLOYER_UPDATE', async employerId => {
        if (
          vm.candidateListing.some(
            candidate => candidate.employerId === employerId
          )
        ) {
          const {
            data: updatedCandidatesEmployer,
          } = await CandidateListingApi.getCandidateListing({
            employerId: employerId,
          })

          if (
            updatedCandidatesEmployer &&
            updatedCandidatesEmployer.length > 0
          ) {
            const formatUpdatedCandidates = setCandidateListingData(
              updatedCandidatesEmployer
            )

            formatUpdatedCandidates.forEach(candidate => {
              const index =
                vm.candidateListing &&
                vm.candidateListing.findIndex(({id}) => id === candidate.id)
              vm.candidateListing[index] = candidate
            })

            vm.gridOptions.api.updateRowData({update: formatUpdatedCandidates})
            updateGridGroupPipeline()
          }
        }
      })

      socket.on('APPLICATION_CREATE', async applicationId => {
        const {
          data: applicationCreated,
        } = await ApplicationsApi.getApplicationById(applicationId)
        const updatedCandidate = vm.candidateListing.find(
          ({id}) => id === applicationCreated.userId
        )

        if (updatedCandidate)
          await vm.candidateUpdated(updatedCandidate && updatedCandidate.id)
      })

      const dateFilterParameters = {
        suppressAndOrCondition: true,
        inRangeInclusive: true,
        comparator: function(filterLocalDateAtMidnight, cellValue) {
          const dateAsString = moment(cellValue).format('DD/MM/YYYY')
          const dateParts = dateAsString.split('/')
          const cellDate = new Date(
            Number(dateParts[2]),
            Number(dateParts[1]) - 1,
            Number(dateParts[0])
          )

          if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
            return 0
          }

          if (cellDate < filterLocalDateAtMidnight) {
            return -1
          }

          if (cellDate > filterLocalDateAtMidnight) {
            return 1
          }
        },
      }

      function renderDateTimeColumn(parameters) {
        return parameters.value
          ? `<span>` +
              moment(parameters.value).format('DD-MMM-YYYY HH:mm') +
              `</span>`
          : ' '
      }

      function renderDateMonthColumn(parameter) {
        return parameter.value
          ? `<span>` + moment(parameter.value).format('MMM-YY') + `</span>`
          : ' '
      }

      vm.viewProfile = parameter => {
        if (parameter.data.candidateDetails.approvalStatus === 'New User') {
          $window.open(
            '/profile?user=' + parameter.data.candidateDetails.id,
            '_blank'
          )
        } else vm.candidateProfile(parameter.data.candidateDetails.id)
      }

      vm.candidateProfile = code => {
        modalInstance = $uibModal.open({
          templateUrl: 'candidateProfileModal.html',
          windowClass: 'app-candidate-profile-modal-window',
          controller: 'CandidateProfileModalController',
          resolve: {
            data: function() {
              return code
            },
          },
        })
      }

      const columnDefs = [
        {
          columnGroupShow: undefined,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          width: 134,
          filter: false,
          resizable: false,
        },
        {
          headerName: 'Candidate Details',
          children: [
            {
              headerName: 'Status',
              rowGroupIndex: 0,
              field: 'candidateDetails.approvalStatus',
            },
            {
              headerName: 'Candidate Agent',
              field: 'candidateAgentEmail',
            },
            {
              headerName: 'ID',
              field: 'candidateDetails.id',
              filter: 'agTextColumnFilter',
              columnGroupShow: undefined,
            },
            {
              headerName: 'Email',
              field: 'candidateDetails.email',
              filter: 'agTextColumnFilter',
            },
            {
              headerName: 'Phone #',
              field: 'candidateDetails.phone',
              filter: 'agTextColumnFilter',
            },
            {
              headerName: 'Platform Access',
              field: 'candidateDetails.platformAccess',
            },
          ],
        },
        {
          headerName: 'Candidate Profile',
          children: [
            {
              headerName: 'Candidate Name',
              field: 'candidateProfile.fullName',
              onCellClicked: vm.viewProfile,
              filter: 'agTextColumnFilter',
              cellRenderer: function(parameter) {
                return parameter.value
                  ? `<span class="text-info pointer"/>${parameter.value}</span>`
                  : ``
              },
              columnGroupShow: undefined,
            },
            {
              headerName: 'Qualification Date',
              field: 'candidateProfile.qualificationDate',
              cellRenderer: renderDateMonthColumn,
              filter: 'agDateColumnFilter',
              filterParams: dateFilterParameters,
            },
            {
              headerName: 'PQE',
              field: 'candidateProfile.pqe',
              filterParams: {
                comparator: function(a, b) {
                  var numberA = Number.parseFloat(a)
                  var numberB = Number.parseFloat(b)
                  if (numberA > numberB) {
                    return 1
                  }

                  return numberA < numberB ? -1 : 0
                },
              },
            },
            {
              headerName: 'Current Location',
              field: 'candidateProfile.currentLocation',
            },
            {
              headerName: 'Languages',
              field: 'candidateProfile.languages',
            },
            {
              headerName: 'Jurisdiction(s) of Qualification',
              field: 'candidateProfile.jurisdictions',
            },
            {
              headerName: 'University',
              field: 'candidateProfile.school',
            },
            {
              headerName: 'Nationality',
              field: 'candidateProfile.nationality',
            },
          ],
        },
        {
          headerName: 'Candidate Experience',
          children: [
            {
              headerName: 'Current Employer',
              field: 'currentExperience.employer.name',
              columnGroupShow: undefined,
            },
            {
              headerName: 'Current Employer Type',
              field: 'currentExperience.employerType',
            },
            {
              headerName: 'Current Employer Selectivity',
              field: 'currentExperience.employer.selectivity',
            },
            {
              headerName: 'Current Job Title',
              field: 'currentExperience.jobTitle',
            },
            {
              headerName: 'Current Practice Areas',
              field: 'currentExperience.specialties',
            },
            {
              headerName: 'Current Occupation',
              field: 'currentExperience.occupation',
            },
            {
              headerName: 'Current Contract',
              field: 'currentExperience.contractType',
            },
            {
              headerName: 'Current Salary Currency',
              field: 'currentExperience.salary.salaryUnit',
            },
            {
              headerName: 'Current Salary Amount',
              field: 'currentExperience.salary.salaryAmount',
            },
            {
              headerName: 'Current Salary Period',
              field: 'currentExperience.salary.salaryPeriod',
            },
            {
              headerName: 'Current Bonus Currency ',
              field: 'currentExperience.salary.bonusUnit',
            },
            {
              headerName: 'Current Bonus Amount',
              field: 'currentExperience.salary.bonusAmount',
            },
          ],
        },
        {
          headerName: 'Candidate Preferences',
          children: [
            {
              headerName: 'Practice Area Preference',
              field: 'legalCandidatePracticeAreas',
              columnGroupShow: undefined,
              filter: undefined,
            },
            {
              headerName: 'Location Preference',
              field: 'candidatePreference.locations',
              cellRenderer: function(parameter) {
                return getLocationsTags(parameter.value)
              },
            },
            {
              headerName: 'Contract Preference',
              field: 'candidatePreference.contracts',
              cellRenderer: function(parameter) {
                if (parameter.value)
                  return ` <li class="label label-info text-uppercase margin-r5" style="background-color : #DEDEDE; color: black;">
                ${parameter.value}
              </li> `
              },
            },
            {
              headerName: 'Occupation Preference',
              field: 'candidatePreference.occupations',
              cellRenderer: function(parameter) {
                if (parameter.value)
                  return ` <li class="label label-info text-uppercase margin-r5" style="background-color : #DEDEDE; color: black;">
                ${parameter.value}
              </li> `
              },
            },
            {
              headerName: 'Employer Type Preference',
              field: 'candidatePreference.legalEmployerType',
            },
            {
              headerName: 'Employers Followed',
              field: 'followEmployersName',
            },
            {
              headerName: 'Employers Hidden',
              field: 'hiddenEmployersName',
            },
            {
              headerName: 'Positions Applied',
              field: '',
            },
            {
              headerName: 'Positions Hidden',
              field: '',
            },
          ],
        },
        {
          headerName: 'Candidate Activity',
          children: [
            {
              headerName: 'Candidate Status',
              field: 'candidateActivity.candidateStatus',
            },
            {
              headerName: 'Last Login',
              field: 'candidateActivity.lastLogin',
              cellRenderer: renderDateTimeColumn,
              columnGroupShow: undefined,
              filter: 'date',
              filterParams: dateFilterParameters,
            },
            {
              headerName: 'Approval Date',
              field: 'candidateActivity.approvalAcceptDate',
              cellRenderer: renderDateTimeColumn,
              filter: 'date',
              filterParams: dateFilterParameters,
            },
            {
              headerName: 'Request Access Date',
              field: 'candidateActivity.approvalRequestDate',
              cellRenderer: renderDateTimeColumn,
              filter: 'date',
              filterParams: dateFilterParameters,
            },
            {
              headerName: 'Signup Date',
              field: 'candidateActivity.created',
              cellRenderer: renderDateTimeColumn,
              filter: 'date',
              filterParams: dateFilterParameters,
            },
            {
              headerName: '# Logins',
              field: 'candidateActivity.loginCount',
            },
            {
              headerName: '# Conversation Notes',
              field: 'candidateActivity.totalConversationNote',
            },
            {
              headerName: 'Last Conversation Date',
              field: 'candidateActivity.lastConversationNote',
              cellRenderer: renderDateTimeColumn,
              filter: 'date',
              filterParams: dateFilterParameters,
            },
            {
              headerName: '# Employers Followed',
              field: 'followEmployer.length',
            },

            {
              headerName: '# Employers Hidden',
              field: 'hiddenEmployer.length',
            },
            {
              headerName: '# Positions Hidden',
              field: 'hiddenPosition.length',
            },
            {
              headerName: '# Positions Applied: Reg/Cust',
              field: 'totalAppliedPositionRegularCustom',
            },
            {
              headerName: '# MakeMeAnOffer',
              field: 'totalAppliedPositionSpecConnect',
            },
            {
              headerName: 'Recently Moved',
              field: 'recentlyMoved',
            },
            {
              headerName: 'Email Alerts: In-House ATS-Links',
              field: 'emailAlertWeeklyInHouseATS',
            },
            {
              headerName: 'Email Alerts: Daily + Adhoc Matches',
              field: 'emailAlertDailyMatches',
            },
          ],
        },
      ]

      const gridOptions = {
        defaultColDef: {
          sortable: true,
          filter: true,
          enablePivot: true,
          enableRowGroup: true,
          enableValue: true,
          columnGroupShow: 'open',
          resizable: true,
          menuTabs: ['filterMenuTab', 'generalMenuTab', 'columnsMenuTab'],
        },
        embedFullWidthRows: true,
        detailRowHeight: 300,
        onFilterChanged: onFilterChanged,
        onModelUpdated: updateGridGroupPipeline,
        onGridReady: function() {
          initializeCandidateListing()
        },
        floatingFilter: true,
        suppressCsvExport: true,
        groupDefaultExpanded: 0,
        groupUseEntireRow: true,
        columnDefs: columnDefs,
        animateRows: true,
        enableCellChangeFlash: true,
        groupSelectsChildren: true,
        rowData: vm.candidateListing,
        rowSelection: 'multiple',
        rowMultiSelectWithClick: true,
        rowGroupPanelShow: 'always',
        pivotPanelShow: 'always',
        groupSelectsFiltered: true,

        postProcessPopup: function(parameter) {
          if (parameter.type !== 'columnMenu') {
            return
          }

          var columnId = parameter.column.getId()
          if (
            columnId === 'candidatePreference.legalPractices' ||
            columnId === 'currentExperience.specialties'
          ) {
            parameter.ePopup.style.width = '350px'
          }
        },
        groupRowRenderer: 'agGroupCellRenderer',
        groupRowRendererParams: {
          checkbox: true,
        },

        getRowNodeId: function(data) {
          return data.id
        },
        onSelectionChanged: onSelectionChanged,

        sideBar: {
          toolPanels: ['columns', 'filters'],
          defaultToolPanel: false,
        },
        statusBar: {
          statusPanels: [
            {statusPanel: 'agTotalRowCountComponent', align: 'left'},
            {statusPanel: 'agFilteredRowCountComponent', align: 'left'},
            {statusPanel: 'agSelectedRowCountComponent'},
            {statusPanel: 'agAggregationComponent'},
          ],
        },

        overlayLoadingTemplate:
          '<span class="ag-overlay-loading-center">Please wait while your data is loading</span>',
        suppressCopyRowsToClipboard: true,
        enableRangeSelection: true,
        enableCharts: true,
        onColumnRowGroupChanged: updateGridGroupPipeline,
        getContextMenuItems,
      }

      vm.gridOptions = gridOptions
      vm.gridName = 'candidate'

      vm.helpTooltip = {
        name: 'Help',
        content: $sce.trustAsHtml(candidateHelpContent),
      }

      function onFilterChanged() {
        vm.filterCount = Object.keys(vm.gridOptions.api.getFilterModel()).length
        // eslint-disable-next-line angular/document-service
        let filterTextBoxValue = document.querySelector('#filter-text-box')
          .value
        if (filterTextBoxValue.length > 0) {
          vm.filterCount += 1
        }

        updatePipelineCountFromGrid()
      }

      // TODO: on grid functionality
      function updatePipelineCountFromGrid() {
        vm.gridOptions.api.forEachNode(node => {
          if (node.key) {
            vm.groupList.map(row => {
              if (row.id === node.id) {
                row.applicationsCount = node.allChildrenCount
                return row
              }

              return row
            })
          }
        })
        $scope.$applyAsync()
      }

      vm.activeActions = [
        {
          funcName: 'Create Candidate',
          function: () => {
            $window.open(
              'https://agent.lexstep.com/candidates/create',
              '_blank'
            )
          },
          icon: `/images/plus-icon.svg`,
          visible: true,
        },
      ]

      // TODO: on grid action items functionality
      function updateGridGroupPipeline() {
        vm.groupList = []

        vm.gridOptions.api.forEachNode(node => {
          if (node.key) {
            let hasChild = true
            if (
              _.isEmpty(node.childrenMapped) ||
              'undefined' in node.childrenMapped
            )
              hasChild = false
            vm.groupList.push({
              name: node.key,
              applicationsCount: node.allChildrenCount,
              color: node.leafGroup
                ? '#' + Math.trunc(Math.random() * 0xffffff).toString(16)
                : lighten('#5e5e5e', (node.level + 1) * 10),
              id: node.id,
              intId: Number(node.id) * -1,
              level: node.level,
              parentID: node.parent.id,
              hasChild: hasChild,
              isHidden: node.level !== 0,
            })
          }
        })
        $log.debug('vm.groupList', vm.groupList)
        $scope.$applyAsync()
      }

      vm.hideAccounts = () => {
        let currentActiveFilters = vm.gridOptions.api.getFilterModel()
        if (vm.actionsFunctions[0].hideAccounts === true) {
          let hiddenData = vm.candidateListing.filter(
            ({candidateDetails}) =>
              candidateDetails.email &&
              candidateDetails.email.toLowerCase().includes('@lexstep') ===
                false &&
              candidateDetails.email &&
              candidateDetails.email.toLowerCase().includes('@emumba') === false
          )
          vm.gridOptions.api.setRowData(hiddenData)
        } else {
          vm.gridOptions.api.setRowData(vm.candidateListing)
        }

        vm.gridOptions.api.setFilterModel(currentActiveFilters)
        vm.actionsFunctions[0].hideAccounts = !vm.actionsFunctions[0]
          .hideAccounts
        if (vm.actionsFunctions[0].funcName === 'Hide Test Accounts')
          vm.actionsFunctions[0].funcName = 'Show Test Accounts'
        else vm.actionsFunctions[0].funcName = 'Hide Test Accounts'
        vm.gridOptions.api.deselectAll()
        onSelectionChanged()
        updateGridGroupPipeline()
      }

      vm.splitGrid = value => {
        vm.showCv.isShow = value
        const agGridListingDiv = document.querySelector(`#${vm.gridName}`)
        const cvDiv = document.querySelector(`#myCV`)
        agGridListingDiv.style.height = window.innerHeight - 235 + 'px'
        agGridListingDiv.style.padding = 0
        cvDiv.style.height = window.innerHeight - 235 + 'px'
        if (value) {
          agGridListingDiv.style.width = '65%'
          agGridListingDiv.classList.add('col-md-7')
        } else agGridListingDiv.style.width = '100%'
      }

      vm.applicationsResume = []

      function onSelectionChanged() {
        vm.selectedRows = vm.gridOptions.api.getSelectedRows()
        vm.selectedRowsLength = vm.selectedRows.length
        hideShowDropdownActionItem()
      }

      const hideShowDropdownActionItem = () => {
        vm.multiSelectOptions = undefined

        const functionName = vm.actionsFunctions[0].funcName
        const hideAccounts = vm.actionsFunctions[0].hideAccounts
        vm.actionsFunctions = [
          {
            funcName: functionName,
            leftClick: vm.hideAccounts,
            values: vm.candidateListing,
            hideAccounts: hideAccounts,
          },
        ]
        if (vm.selectedRowsLength > 0) {
          vm.multiSelectOptions = [
            {
              count: vm.selectedRowsLength,
            },
            {
              funcName: 'Clear Selection',
              function: vm.clearSelection,
            },
          ]
          const functionName = vm.actionsFunctions[0].funcName
          const hideAccounts = vm.actionsFunctions[0].hideAccounts
          vm.actionsFunctions = [
            {
              funcName: functionName,
              leftClick: vm.hideAccounts,
              values: vm.candidateListing,
              hideAccounts: hideAccounts,
            },
            {
              funcName: 'Actions',
              disabled: vm.selectedRowsLength !== 1,
              leftClick: vm.openActionsModal,
            },
            {
              funcName: 'Delete',
              leftClick: vm.deleteCandidate,
              disabled: !(vm.selectedRowsLength > 0),
              masterOnly: vm.isAllowedAgent(),
            },
          ]
          vm.gridDataActions = [
            {
              count: vm.selectedRowsLength,
            },
          ]
        }

        $scope.$applyAsync()
      }

      vm.isAllowedAgent = () => {
        return vm.user.roles.some(
          role => role.id === 'admin' || role.id === 'ops'
        )
      }

      vm.openActionsModal = async () => {
        var selectedRows = gridOptions.api.getSelectedRows()
        // eslint-disable-next-line no-negated-condition
        if (selectedRows[0].candidateDetails.approvalStatus !== 'New User') {
          vm.selectedCandidate = selectedRows[0].candidateDetails.id
          let modalData
          await Promise.allSettled([
            CandidateProfileApi.getUserProfile(vm.selectedCandidate),
            CandidateProfileApi.getUserBlockedEmployers(vm.selectedCandidate),
            CandidateProfileApi.getAdminAndCorporateUsers(),
            CandidateProfileApi.getUserSettings(vm.selectedCandidate),
            CandidateProfileApi.getEmployersList(),
          ]).then(results => {
            const blockedEmployersList = results[4].value.data.map(employer => {
              return Object.assign(
                {
                  isSelected: Boolean(
                    results[1].value.data.find(
                      blockedEmployer =>
                        blockedEmployer.employerId === employer.id &&
                        blockedEmployer.block
                    )
                  ),
                },
                employer
              )
            })
            vm.assignableAgents = results[2].value.data
            modalData = {
              candidate: results[0].value.data,
              blockedEmployers: results[1].value.data,
              assignableAgents: vm.assignableAgents,
              candidateSettings: results[3].value
                ? results[3].value.data
                : [{id: 1, hasValue: false}],
              employersList: blockedEmployersList,
            }
          })

          const modalInstance = $uibModal.open({
            templateUrl: 'edit-candidate-modal.html',
            controller: 'EditCandidateCtrl',
            controllerAs: 'ctrl',
            resolve: {
              data: function() {
                return modalData
              },
              candidateId: function() {
                return vm.selectedCandidate
              },
            },
          })
          modalInstance.result.then(async () => {})
        } else {
          logger.notify('warning', 'Actions is not available for New User')
        }
      }

      // Function for Delete Lawyer
      vm.deleteCandidate = () => {
        var selectedRows = gridOptions.api.getSelectedRows()
        let selectedUserIds = selectedRows.map(x => x.candidateDetails.id)
        var modalInstance
        modalInstance = $uibModal.open({
          templateUrl: 'deleteLawyerModal.html',
          controller: 'deleteMatterModalCtrl',
          resolve: {
            data: function() {
              return vm.loggedInLawyer
            },
          },
        })
        modalInstance.result.then(
          selectedItem => {
            if (selectedItem) {
              CandidateListingApi.deleteUsers(selectedUserIds).then(
                () => {
                  vm.gridOptions.api.updateRowData({remove: selectedRows})
                  selectedRows.forEach(row => {
                    vm.candidateListing.splice(
                      vm.candidateListing &&
                        vm.candidateListing.findIndex(
                          x => x.candidateDetails.id === row.candidateDetails.id
                        ),
                      1
                    )
                  })
                  let message = 'Successfully deleted'
                  logger.notify('success', message)
                  $rootScope.isCandidateDeleted = true
                },
                () => {}
              )
            }
          },
          () => {}
        )
      }

      // On clicking any referral code it will redirect on referral page with specific code filter
      // eslint-disable-next-line no-unused-vars
      function redirectToReferrals(parameter) {
        if (
          parameter.data.candidateDetails.referredById &&
          parameter.data.candidateDetails.referredBy !== ''
        )
          $window.open(
            '/admin/referral-listing?filterName=referralCode&filterValue=' +
              parameter.data.candidateDetails.referredById,
            '_blank'
          )
      }

      function getContextMenuItems(parameter) {
        var result = [
          {
            name: 'Open profile in new tab ',
            action: function() {
              if (
                parameter.node.data.candidateDetails.approvalStatus ===
                'New User'
              ) {
                $window.open(
                  '/profile?user=' + parameter.node.data.candidateDetails.id,
                  '_blank'
                )
              } else
                $window.open(
                  '/admin/lawyer-profile?user=' +
                    parameter.node.data.candidateDetails.id,
                  '_blank'
                )
            },
          },
          'separator',
          {
            name: 'Expand All Columns',
            action: function() {
              var columnApi = parameter.columnApi.getColumnGroupState()
              columnApi.forEach(item => {
                parameter.columnApi.setColumnGroupOpened(item.groupId, true)
              })
            },
          },
          {
            name: 'Collapse All Columns',
            action: function() {
              var columnApi = parameter.columnApi.getColumnGroupState()
              columnApi.forEach(item => {
                parameter.columnApi.setColumnGroupOpened(item.groupId, false)
              })
            },
          },
          'separator',
          'copy',
          'copyWithHeaders',
          'separator',
          'chartRange',
        ]
        vm.isExportAllowed = vm.user.roles.some(
          role => role.id === 'admin' || role.id === 'ops'
        )
        if (vm.isExportAllowed) result.push('export')
        return result
      }

      vm.actionsFunctions = [
        {
          funcName: 'Hide Test Accounts',
          leftClick: vm.hideAccounts,
          values: vm.candidateListing,
          hideAccounts: true,
        },
      ]

      let modalInstance
      vm.profileLink = referralCode => {
        modalInstance.close()
        $window.open('/admin/lawyer-profile?user=' + referralCode, '_blank')
      }

      vm.loadCandidateListing = candidateRecord => {
        vm.candidateListing = setCandidateListingData(candidateRecord)
        vm.gridOptions.api.setRowData(vm.candidateListing)
        if (defaultFilter) vm.gridOptions.api.setFilterModel(defaultFilter)
        $rootScope.$broadcast('listing-loaded')

        updateGridGroupPipeline()
        $scope.$apply()
      }

      const setCandidateListingData = candidateRecord => {
        return candidateRecord.map(data => {
          data.matchingEmployerFollowed =
            data.followEmployer.length > 0 &&
            data.followEmployer.find(
              employer => employer.id === Number(vm.employerId)
            )
              ? 'Yes'
              : 'No'

          data.matchingPositionHidden =
            data.hiddenPosition.length > 0 &&
            data.hiddenPosition.find(
              position => position.id === Number(vm.positionId)
            )
              ? 'Yes'
              : 'No'

          data.matchingEmployerHidden =
            data.hiddenEmployer.length > 0 &&
            data.hiddenEmployer.find(
              employer => employer.id === Number(vm.employerId)
            )
              ? 'Yes'
              : 'No'

          data.followEmployersName =
            data.followEmployer.length > 0
              ? vm.employersNameList
                  .filter(({id}) =>
                    data.followEmployer.find(employer => employer.id === id)
                  )
                  .map(employer => employer.name)
              : ''
          data.hiddenEmployersName =
            data.hiddenEmployer.length > 0
              ? vm.employersNameList
                  .filter(({id}) =>
                    data.hiddenEmployer.find(employer => employer.id === id)
                  )
                  .map(employer => employer.name)
              : ''

          if (data.appliedPosition.length > 0) {
            const regularCustomAppliedPosition = data.appliedPosition.find(
              ({lastAppliedDateRegularCustom}) =>
                lastAppliedDateRegularCustom !== null
            )
            if (regularCustomAppliedPosition) {
              data.lastAppliedDateRegularCustom =
                regularCustomAppliedPosition.lastAppliedDateRegularCustom
              data.totalAppliedPositionRegularCustom =
                regularCustomAppliedPosition.totalAppliedPositionRegularCustom
            }

            const specConnectAppliedPosition = data.appliedPosition.find(
              ({lastAppliedDateSpecConnect}) =>
                lastAppliedDateSpecConnect !== null
            )
            if (specConnectAppliedPosition) {
              data.lastAppliedDateSpecConnect =
                specConnectAppliedPosition.lastAppliedDateSpecConnect
              data.totalAppliedPositionSpecConnect =
                specConnectAppliedPosition.totalAppliedPositionSpecConnect
            }
          }

          setCandidateDetailsColumnsData(data, vm)
          setCandidateProfileColumnsData(data, vm)
          if (
            data.currentExperience.employer &&
            data.currentExperience.employerId
          )
            setCurrentExperienceColumnsData(data, vm)
          setCandidatePreferenceColumnsData(data, vm)
          setCandidateActivityColumnsData(data, vm)
          data.recentlyMoved =
            data.currentExperience.isLastJob &&
            new Date(data.currentExperience.startDate) >=
              new Date(lastSixMonthDate())
              ? '< 6 months'
              : 'No'
          return data
        })
      }

      const startSpinner = name => usSpinnerService.spin(name)
      const stopSpinner = name => usSpinnerService.stop(name)

      vm.sliderFilter = filterPqe => {
        let separator = filterPqe.pqe.search(';')
        let minPQE = Number(filterPqe.pqe.slice(0, separator))
        let maxPQE = Number(
          filterPqe.pqe.slice(separator + 1, filterPqe.pqe.length)
        )
        if (maxPQE === 11) maxPQE = 50
        if (minPQE === -2) minPQE = -20
        let range = _.range(minPQE, maxPQE + 0.5, 0.5)
        let filterValues = range.map(element => String(element))
        let currentActiveFilters = vm.gridOptions.api.getFilterModel()
        if (maxPQE === 50 && minPQE === -20) {
          delete currentActiveFilters['candidateProfile.pqe']
          gridOptions.api.setFilterModel(currentActiveFilters)
        } else {
          currentActiveFilters['candidateProfile.pqe'] = {
            values: filterValues,
            filterType: 'set',
          }
          gridOptions.api.setFilterModel(currentActiveFilters)
        }

        $scope.$applyAsync()
      }

      vm.updateSelectedCandidateAgent = async selectedAgent => {
        const selectedRow = vm.gridOptions.api.getSelectedRows()
        const selectedUserIds = selectedRow.map(x => x.candidateDetails.id)
        const result = await updateBulkUserAgentApi(
          selectedUserIds,
          selectedAgent.email,
          selectedRow
        )

        if (result === 200) {
          logger.notify(
            'success',
            selectedUserIds.length +
              ' candidate' +
              (selectedUserIds.length > 1 ? 's' : '') +
              " assigned to '" +
              selectedAgent.email +
              "'"
          )
          vm.gridOptions.api.deselectAll()
          $('#agentsDropdownList').hide()
        }
      }

      const updateBulkUserAgentApi = async (
        userIds,
        selectedAgentEmail,
        selectedRow
      ) => {
        const agent =
          selectedAgentEmail === 'unassign'
            ? // eslint-disable-next-line unicorn/no-null
              {id: null, email: 'unassigned'}
            : vm.agentsList.find(({email}) => email === selectedAgentEmail)
        const payload = {userIds, agentId: agent.id}
        try {
          const {status} = await CandidateListingApi.updateBulkUserAgents(
            payload
          )
          if (status === 200) {
            selectedRow.map(row => {
              row.candidateAgentEmail = agent.email
              return row
            })
            vm.gridOptions.api.updateRowData({update: selectedRow})
            return status
          }
        } catch (error) {
          logger.notify('error', error.data.message)
        }
      }

      const initializeCandidateListing = async () => {
        vm.user = await userService.getUser()
        vm.positionId = $location.search().positionId
        vm.employerId = $location.search().employerId
        vm.innerHeight = $location.search().innerHeight

        startSpinner('candidate-listing')
        const [
          {data: candidateList},
          {data: agentsList},
          {data: locationsList},
          {data: languagesList},
          {data: nationalitiesList},
          {data: schoolList},
          {data: legalPracticeAreaList},
          {data: legalEmployerTypeList},
          {data: legalJurisdictionList},
          {data: contractTypeList},
          {data: occupationList},
          {data: employersNameList},
          {data: userLoginActions},
          {data: userAllConversationNotes},
        ] = await Promise.all([
          CandidateListingApi.getCandidateListing(),
          CandidateProfileApi.getAdminAndCorporateUsers(),
          SharedApi.getAllLocations({
            regions: true,
          }),
          SharedApi.getAllLanguages(),
          SharedApi.getAllNationalities(),
          SharedApi.getAllSchools(),
          SharedApi.getCategoryById(1),
          SharedApi.getCategoryById(2),
          SharedApi.getCategoryById(3),
          SharedApi.getAllContractTypes(),
          SharedApi.getAllOccupations(),
          EmployersApi.getAllEmployers({include: ['id', 'name']}),
          SharedApi.getAllActions({
            category: 'user',
            type: 'USER_LOGIN',
            include: true,
          }),
          NotesApi.getAllNotes({
            category: 'Conversation',
            type: 'user',
            includes: true,
          }),
        ])
        vm.userLoginActions = userLoginActions
        vm.userAllConversationNotes = userAllConversationNotes
        vm.agentsList = agentsList
        vm.legalPracticeAreaList = legalPracticeAreaList.specialties
        console.debug(
          'initializeCandidateListing::legalPracticeAreaList',
          legalPracticeAreaList
        )
        vm.legalEmployerTypeList = legalEmployerTypeList.specialties
        vm.jurisdictionList = legalJurisdictionList.specialties
        vm.locationsList = locationsList
        vm.languagesList = languagesList
        vm.nationalitiesList = nationalitiesList
        vm.schoolList = schoolList
        vm.contractTypesList = contractTypeList
        vm.occupationList = occupationList
        vm.employersNameList = employersNameList
        vm.onlyParentPracticeAreaList = vm.legalPracticeAreaList.filter(
          ({parentId}) => parentId === null
        )

        vm.gridActionsDirective = {
          pqeSlider: {
            function: vm.sliderFilter,
            params: {
              options: {
                round: 1,
                from: -2,
                to: 11,
                step: 0.5,
                dimension: ' years',
                scale: ['≤-2', -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, '≥11'],
              },
              filterPQE: {
                pqe: '-2;11',
              },
            },
            buttonId: 'lawyer-listing-pqe-slider',
            icon: 'images/stage.svg',
          },
          practices: {
            buttonId: 'candidate-listing-filter-prac',
            allPracticeAreaList: vm.onlyParentPracticeAreaList,
            iconLabel: 'Filter by Practice Area',
          },
          assignAgent: {
            buttonId: 'assignee-admin-filter',
            agentsList: vm.agentsList,
            function: vm.updateSelectedCandidateAgent,
            filteredAgentList: vm.agentsList,
          },
        }

        if ($location.search().filterName && $location.search().filterValue) {
          let columnList = []
          columnDefs.forEach(row => {
            if (row.children) columnList.push(row.children)
          })
          const filterName = $location.search().filterName
          const filterValue = $location.search().filterValue
          const employerName = vm.employersNameList.find(
            row => row.id === Number(filterValue)
          ).name
          columnList = columnList.flat(Infinity)
          let column = columnList.find(row => row.field === filterName)
          if (column && column.field) {
            defaultFilter = JSON.parse(
              column.filter === 'agTextColumnFilter'
                ? `{"${filterName}":{"filterType":"text","type":"contains","filter":"${employerName}"}}`
                : `{"${filterName}":{"values":["${employerName}"],"filterType":"set"}}`
            )
          }
        }

        vm.loadCandidateListing(candidateList)
        stopSpinner('candidate-listing')
      }

      let getLocationsTags = locations => {
        let locationTags = ``
        // eslint-disable-next-line unicorn/explicit-length-check
        if (locations && locations.length) {
          locations.forEach(locationName => {
            const {color, flag} = getLocationColorAndFlag(locationName)
            locationTags += ` <li class="label label-info text-uppercase margin-r5 location-${color}">
          ${flag} ${locationName}
        </li> `
          })
        }

        return locationTags
      }
    },
  ])
})()

const lastSixMonthDate = () => {
  const today = new Date()
  return today.setMonth(today.getMonth() - 6)
}

const addLight = (color, amount) => {
  let cc = Number.parseInt(color, 16) + amount
  let c = cc > 255 ? 255 : cc
  c = c.toString(16).length > 1 ? c.toString(16) : `0${c.toString(16)}`
  return c
}

const lighten = (color, amount) => {
  color = color.includes('#') ? color.slice(1, color.length) : color
  // eslint-disable-next-line radix
  amount = Number.parseInt((255 * amount) / 100)
  color = `#${addLight(color.slice(0, 2), amount)}${addLight(
    color.slice(2, 4),
    amount
  )}${addLight(color.slice(4, 6), amount)}`
  return color
}

const candidateHelpContent = `
<div>
					<p>The Lawyers list displays LexStep candidates and allows you to search for candidates based on specific criteria you define.</p>					
					<b>My Candidates</b>
					<p>Filter by “My Candidates” from the toolbar above the grid to display your assigned candidates only.</p>					
					<b>Filtering</b>
					<p> “Filter by PQE” and “Filter by Practice Area Preference” icons allow you to quickly refine your search. Further filters can be applied by hovering over each column header and selecting the hamburger menu on the right. </p>
					<b>Views</b>
					<p>Personalise different list layouts by choosing the columns to display, adjusting their width and moving them to re-order to your preferences. You can save custom column layouts with filter criteria to easy access again later via the “Views” icon in the top right -- either as a Private “Saved View” or Shared with other team members.</p>
					<b>Clear</b>
					<p>When one or more filters are applied, a Clear filter icon will appear in the top right above the grid. Select to clear any applied filters and/or search and reset the grid data to default. </p>
          <b>Group</b>
					<p>Drag and drop columns to the grouping drop zone in the grid’s top row to group rows by a particular column.</p>
					<b>Sorting </b>
					<p>Candidates are sorted by Candidate ID in descending order, showing the latest candidate to sign up first by default. You can change how the list is ordered by clicking the column headers to sort. To sort by multiple columns, hold down shift while clicking the column header.</p>
					<b>Candidate Profile</b>
					<p>You can quickly view more details about each candidate on the list by clicking their hyperlinked name. A preview pane will open that lets you toggle between the candidate’s Profile, Preferences, Applications, Notes, Position Matches and Speculative Make-Me-An-Offer opportunities.</p>
					<b>Actions</b>
          <p>Selecting one or more rows enables bulk actions like Assign Admin which are accessible from the toolbar icons above the grid.</p>	
          <b>New Users</b>
          <p>Clicking a New User’s hyperlinked name will open their incomplete sign up form allowing you to review their progress and any issues they may have experienced in Requesting Access.  </p>
          <p>To preview a New User’s full LexStep profile and, for example, leave an internal Note: (1) copy their Referral Code from the Candidate Details column group; and (2) paste in a new tab at the end of this URL
          <a href="https://www.lexstep.com/admin/lawyer-profile?user=" target="_blank">https://www.lexstep.com/admin/lawyer-profile?user=</a>
          </div> `

const setCandidateDetailsColumnsData = (data, vm) => {
  data.candidateDetails.referralCode = data.candidateDetails.id
  data.candidateAgentEmail = data.candidateDetails.agentId
  data.candidateAgentEmail = data.candidateDetails.agentId
  data.candidateAgentEmail = data.candidateDetails.agentId
    ? vm.agentsList.find(agent => agent.id === data.candidateDetails.agentId)
      ? vm.agentsList.find(agent => agent.id === data.candidateDetails.agentId)
          .email
      : 'unassigned'
    : 'unassigned'
  const platformAccess = data.candidateDetails.platformAccess
  const leadAccount = data.candidateDetails.leadAccount
  data.candidateDetails.platformAccess = platformAccess
    ? 'Candidate Account'
    : leadAccount
    ? 'Lead Account'
    : 'No Platform Access'
  return data
}

const setCandidateProfileColumnsData = (data, vm) => {
  data.candidateProfile.fullName = `${data.candidateProfile.firstName} ${data.candidateProfile.lastName}`
  data.candidateProfile.pqe = data.candidateProfile.qualificationDate
    ? formatQualificationDateToPqe(data.candidateProfile.qualificationDate)
    : ''
  if (data.candidateProfile.currentLocation) {
    const location = vm.locationsList.find(
      location => location.id === data.candidateProfile.currentLocation
    )
    data.candidateProfile.currentLocation = location ? location.name : ''
  }

  data.candidateProfile.languages =
    data.candidateProfile.languages.length > 0
      ? vm.languagesList
          .filter(({code}) =>
            data.candidateProfile.languages.find(
              language => language.code === code
            )
          )
          .map(language => language.name)
      : ''
  data.candidateProfile.jurisdictions =
    data.candidateProfile.jurisdictions.length > 0
      ? vm.jurisdictionList
          .filter(({id}) =>
            data.candidateProfile.jurisdictions.find(
              jurisdiction => jurisdiction.id === id
            )
          )
          .map(jurisdiction => jurisdiction.name)
      : ''

  data.candidateProfile.school = data.candidateProfile.school
    ? vm.schoolList.find(school => school.id === data.candidateProfile.school)
        .name
    : ''

  data.candidateProfile.nationality =
    data.candidateProfile.nationalities &&
    data.candidateProfile.nationalities.length > 0
      ? vm.nationalitiesList
          .filter(({code}) =>
            data.candidateProfile.nationalities.find(
              nationality => nationality.code === code
            )
          )
          .map(nationality => nationality.demonyms[0])
      : ''
  return data
}

const setCurrentExperienceColumnsData = (data, vm) => {
  data.currentExperience.contractType = data.currentExperience.contractTypeId
    ? vm.contractTypesList.find(
        contract => contract.id === data.currentExperience.contractTypeId
      ).name
    : undefined
  data.currentExperience.occupation = data.currentExperience.occupationId
    ? vm.occupationList.find(
        occupation => occupation.id === data.currentExperience.occupationId
      ).name
    : undefined
  data.currentExperience.specialties =
    data.currentExperience.positionSpecialties.length > 0
      ? vm.legalPracticeAreaList
          .filter(({id}) =>
            data.currentExperience.positionSpecialties.find(
              specialty => specialty.id === id
            )
          )
          .map(specialty => specialty.name)
      : ''
  data.currentExperience.employerType =
    data.currentExperience.employerSpecialties.length > 0
      ? vm.legalEmployerTypeList
          .filter(({id}) =>
            data.currentExperience.employerSpecialties.find(
              specialty => specialty.id === id
            )
          )
          .map(specialty => specialty.name)
      : ''
  let currentEmployerSelectivity = ''
  if (data.currentExperience.employer.selectivity) {
    for (
      let index = 1;
      index <= data.currentExperience.employer.selectivity;
      index++
    ) {
      currentEmployerSelectivity += '$'
    }
  }

  if (data.currentExperience.employer.selectivity === 0)
    currentEmployerSelectivity = 'Uncategorized'
  data.currentExperience.employer.selectivity = currentEmployerSelectivity

  return data
}

const setCandidateActivityColumnsData = (data, vm) => {
  data.candidateActivity.loginCount =
    vm.userLoginActions.find(({userId}) => userId === data.id) &&
    Number(vm.userLoginActions.find(({userId}) => userId === data.id).count)
  data.candidateActivity.totalConversationNote =
    vm.userAllConversationNotes.find(({userId}) => userId === data.id) &&
    Number(
      vm.userAllConversationNotes.find(({userId}) => userId === data.id).count
    )
  data.candidateActivity.lastConversationNote =
    vm.userAllConversationNotes.find(({userId}) => userId === data.id) &&
    vm.userAllConversationNotes.find(({userId}) => userId === data.id).created
  data.emailAlertDailyMatches =
    data.candidateActivity.emailSubscription.length > 0
      ? data.candidateActivity.emailSubscription.find(
          ({id}) => id === 'daily_positions_ping'
        ) &&
        data.candidateActivity.emailSubscription.find(
          ({id}) => id === 'daily_positions_ping'
        ).status
      : 'Active'
  data.emailAlertWeeklyInHouseATS =
    data.candidateActivity.emailSubscription.length > 0
      ? data.candidateActivity.emailSubscription.find(
          ({id}) => id === 'weekly_position_ping'
        ) &&
        data.candidateActivity.emailSubscription.find(
          ({id}) => id === 'weekly_position_ping'
        ).status
      : 'Active'

  return data
}

const setCandidatePreferenceColumnsData = (data, vm) => {
  data.legalCandidatePracticeAreas =
    data.candidatePreference.specialties.length > 0
      ? vm.legalPracticeAreaList
          .filter(({id}) =>
            data.candidatePreference.specialties.find(
              specialty => specialty.id === id
            )
          )
          .map(specialty => specialty.name)
      : ''
  data.candidatePreference.legalEmployerType =
    data.candidatePreference.specialties.length > 0
      ? vm.legalEmployerTypeList
          .filter(({id}) =>
            data.candidatePreference.specialties.find(
              specialty => specialty.id === id
            )
          )
          .map(specialty => specialty.name)
      : ''
  data.candidatePreference.contracts =
    data.candidatePreference.contracts.length > 0
      ? vm.contractTypesList
          .filter(({id}) =>
            data.candidatePreference.contracts.find(
              contractType => contractType.id === id
            )
          )
          .map(contractType => contractType.name)
      : undefined
  data.candidatePreference.occupations =
    data.candidatePreference.occupations.length > 0
      ? vm.occupationList
          .filter(({id}) =>
            data.candidatePreference.occupations.find(
              occupation => occupation.id === id
            )
          )
          .map(occupation => occupation.name)
      : undefined

  data.candidatePreference.locations =
    data.candidatePreference.locations.length > 0
      ? vm.locationsList
          .filter(({id}) =>
            data.candidatePreference.locations.find(
              location => location.id === id
            )
          )
          .map(location => {
            return location.name
          })
      : ''
  // Data.candidatePreference.locations =
  //   data.candidatePreference.locations.length > 0
  //     ? vm.locationsList
  //         .filter(({id}) =>
  //           data.candidatePreference.locations.find(
  //             location => location.id === id
  //           )
  //         )
  //         .map(location => {
  //           return {
  //             name: location.name,
  //             color:
  //               location.countryCode === 'GB'
  //                 ? 'london'
  //                 : location.country.region.color,
  //           }
  //         })
  //     : ''

  return data
}



// WEBPACK FOOTER //
// ./scripts/admin-panel/candidate-listing/candidate-listing.ctrl.js